export const i18n = {
	errorPageText: {
		en: 'An error occurred. Please try again later.',
		es: 'Se produjo un error. Por favor, vuelva a intentar más tarde.',
	},
	noResultsFoundFor: {
		en: '0 results found for',
		es: 'No hay resultados',
	},
	pageNotFoundTitle: {
		en: 'Page Not Found',
		es: 'No se encontró la página',
	},
	pleaseCheckSpellingOrTryAnotherSearch: {
		en:
			'Please check your spelling or try another search using a different word.',
		es:
			'Please check your spelling or try another search using a different word.',
	},
	search: {
		en: 'Search',
		es: 'Buscar',
	},
};
